import type { FieldValues, Path } from "react-hook-form";

import Combobox from "../inputs/combobox";
import type { Option } from "../inputs/select-option.types";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";

type ComboboxFormFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  items: Option[];
  placeholder?: string;
  disabled?: boolean;
  label: string;
  showAll?: boolean;
};

function ComboboxFormField<
  TFieldValues extends FieldValues,
>(
  props: Readonly<
    ComboboxFormFieldProps<TFieldValues>
  >,
) {
  return (
    <FormField
      name={props.name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{props.label}</FormLabel>
          <FormControl>
            <Combobox
              {...field}
              disabled={props.disabled}
              placeholder={props.placeholder}
              items={props.items}
              showAll={props.showAll}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default ComboboxFormField;
